export default "https://legacy.eskolare-development.com/images/router-offline.png";